import { Site } from '@envato/foundation-types'

export const allDomains = [
  'activeden.net',
  'audiojungle.net',
  'themeforest.net',
  'videohive.net',
  'graphicriver.net',
  '3docean.net',
  'codecanyon.net',
  'photodune.net',
  'market.styleguide.envato.com',
  'elements.envato.com',
  'author.envato.com',
  'envato.com'
]

// The order of exported sites determines the order of logotypes
// in the header.
export const siteNames = [
  Site.themeforest,
  Site.codecanyon,
  Site.videohive,
  Site.audiojungle,
  Site.graphicriver,
  Site.photodune,
  Site.threedocean
]
